import React from "react";
import { Database } from "lucide-react";
import MetaBridgePage from "./MetaBridgePage";

export default function ServiceIns() {
  return (
    <MetaBridgePage
      title="MetaBridge INS : Identité Nationale de Santé · MetaConnect"
      metaDescription="Identifiez le patient avec l'INS : interrogation du téléservice INSi et qualification de l'identité directement dans votre logiciel métier."
      canonical="/services/ins"
      eyebrow="Identité Nationale de Santé"
      h1="Qualifier l'identité du patient avec l'INS."
      intro="MetaBridge INS sécurise l'identification du patient en interrogeant le téléservice INSi et en qualifiant son Identité Nationale de Santé directement depuis votre logiciel — pré-requis aux échanges DMP, MSSanté et imagerie."
      icon={<Database size={26} />}
      testIdSlug="ins"
      bullets={[
        "Interrogation du téléservice INSi (carte Vitale ou traits)",
        "Récupération automatique du NIR, nom, prénom, sexe, date et lieu de naissance",
        "Qualification de l'identité selon les statuts ANS",
        "Gestion des homonymies et changements de NIR",
        "Pré-requis pour le DMP, la MSSanté patient, l'imagerie partagée",
        "Conforme au Référentiel d'Identification Nationale de Santé",
      ]}
      details={[
        { title: "Standards", desc: "Téléservice INSi (CNAM), profils IHE PIX/PDQ." },
        { title: "Authentification", desc: "Pro Santé Connect ou carte CPS/CPx." },
        { title: "Statuts", desc: "Récupéré · Validé · Identifié · Provisoire · Qualifié · Récupéré + identité valide." },
      ]}
      useCases={[
        { tag: "Cabinet", title: "Médecin libéral", desc: "À l'ouverture du dossier patient, l'INS est récupérée et qualifiée automatiquement." },
        { tag: "Hôpital", title: "Bureau des entrées", desc: "Réconciliation des identités historiques avec leur INS lors de l'admission." },
        { tag: "Labo", title: "Préanalytique", desc: "L'identitovigilance est renforcée dès la phase pré-analytique." },
        { tag: "Imagerie", title: "Réception examen", desc: "L'INS qualifiée permet de partager l'examen dans le DMP du bon patient." },
      ]}
      faq={[
        { q: "L'INS est-elle obligatoire ?", a: "Oui, depuis le 1er janvier 2021, le référentiel INS impose son utilisation pour tout échange de données de santé à caractère personnel." },
        { q: "Le téléservice INSi est-il payant ?", a: "Non, l'accès au téléservice INSi est gratuit pour les professionnels de santé habilités." },
        { q: "Que se passe-t-il en cas d'homonymie ?", a: "MetaBridge INS expose les traits d'identité et le statut, permettant à l'utilisateur de qualifier manuellement l'INS en levant le doute." },
      ]}
    />
  );
}
